/**
 * Formats a searched destination by:
 * 1. Removing duplicates (e.g., "Paris, Paris, France" -> "Paris, France")
 * 2. Removing "unknown" values
 * 3. Removing empty values
 * @param parts - Array of destination parts (city, region, subRegion, country)
 * @returns The formatted destination string
 */
export const formatSearchedDestination = (
  parts: (string | undefined)[],
): string => {
  const cleanedParts = parts
    .filter((part): part is string => !!part)
    .map((part) => part.trim())
    .filter((part) => part !== '');

  const filteredParts = cleanedParts.filter((part) => {
    const lowerPart = part.toLowerCase();
    return lowerPart !== 'unknown';
  });

  if (filteredParts.length === 0) {
    return '';
  }

  const uniqueParts: string[] = [];
  const seenLowerCase = new Set<string>();

  for (const part of filteredParts) {
    const lowerPart = part.toLowerCase();
    if (!seenLowerCase.has(lowerPart)) {
      seenLowerCase.add(lowerPart);
      uniqueParts.push(part);
    }
  }

  return uniqueParts.join(', ');
};
